<script lang="ts">
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";

  export let saveAndExit: () => void;
  export let submit: () => Promise<void>;
  export let submitButtonText: string;
  export let isDisabled: boolean;
  export let exitIsDisabled: boolean = false;
  export let formDisabled: boolean;
  export let dataTestId: string;
  export let backEnabled: boolean = false;
  export let id: number = null;

</script>

<style>
  .footer-padding-right {
    padding-right: 3rem;
  }

</style>

<footer class="fizz-sticky fizz-full-width fizz-border-top background-white" style="bottom: 0">
  <div
    class="fizz-layout-header fizz-flex-row-0"
    class:fizz-justify-end={!backEnabled}
    class:fizz-space-between={backEnabled}
    class:fizz-inset-stretch-24={$LayoutStore.isMobile}
    class:fizz-inset-square-24={$LayoutStore.isDesktop}
    class:footer-padding-right={$LayoutStore.isDesktop}
  >
    {#if backEnabled}
      <UIRouterLink stateName="layout.apply" params={{ id, step: 1 }} button={true}>
        <button class="fizz-button fizz-flex-row-8" class:fizz-button-icon={$LayoutStore.isDesktop}>
          {#if $LayoutStore.isDesktop}
            <Icon type="ArrowLeft" />
          {/if}
          <span>
            {#if $LayoutStore.isDesktop}
              Back to edit form
            {:else}
              Edit
            {/if}
          </span>
        </button>
      </UIRouterLink>
    {/if}

    <div class="fizz-flex-row-8">
      <button
        class="fizz-button-text"
        disabled={exitIsDisabled || formDisabled || null}
        on:click={saveAndExit}
        data-testId="exit-button">Save and exit</button
      >
      <button
        class="fizz-button-secondary"
        disabled={isDisabled || formDisabled}
        on:click|preventDefault={submit}
        data-testId={dataTestId}
      >
        {$LayoutStore.isMobile ? "Next" : submitButtonText}
      </button>
    </div>
  </div>
</footer>
